var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M33.026 10A3.974 3.974 0 0137 13.974v.043a3.974 3.974 0 01-3.974 3.974H25.5v1.389l9.984 3.719a.994.994 0 01-.003 1.863L25.5 28.638v1.37h7.526A3.974 3.974 0 0137 33.984v.043A3.974 3.974 0 0133.026 38H15.974A3.974 3.974 0 0112 34.026v-.043a3.974 3.974 0 013.974-3.974l7.526-.001v-1.37l-9.982-3.676a.994.994 0 01-.004-1.863L23.5 19.38v-1.389h-7.526A3.974 3.974 0 0112 14.017v-.043A3.974 3.974 0 0115.974 10h17.052z", fill: "currentColor" }))));
});
